import React, { useState } from 'react';
import styled from 'styled-components';
import logo from '../assets/images/header-logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Smooth scroll function
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      // Close mobile menu if open
      if (isMenuOpen) {
        setIsMenuOpen(false);
      }
      
      // Smooth scroll to the section
      section.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  
  return (
    <StyledNavbar>
      <div className="container">
        <LogoContainer>
          <img src={logo} alt="Pulvora Logo" />
        </LogoContainer>
        
        <NavLinks className={isMenuOpen ? 'active' : ''}>
          <NavLink href="#features" onClick={(e) => scrollToSection(e, 'features')}>Features</NavLink>
          <NavLink href="#how-it-works" onClick={(e) => scrollToSection(e, 'how-it-works')}>How It Works</NavLink>
          {/* <NavLink href="#contact-us" onClick={(e) => scrollToSection(e, 'contact-us')}>Contact Us</NavLink> */}
          <NavLink href="#founders" onClick={(e) => scrollToSection(e, 'founders')}>Team</NavLink>
        </NavLinks>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <NavButtons>
            <LoginButton 
              href="#contact-us" 
              className="btn btn-primary" 
              onClick={(e) => scrollToSection(e, 'contact-us')}
            >
              Contact Us
            </LoginButton>
          </NavButtons>
          
          <MenuToggle onClick={() => setIsMenuOpen(!isMenuOpen)} className={isMenuOpen ? 'active' : ''}>
            <span></span>
            <span></span>
            <span></span>
          </MenuToggle>
        </div>
      </div>
    </StyledNavbar>
  );
};

const StyledNavbar = styled.nav`
  padding: 55px 0;
  // background-color: #ffffff;
  // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  @media (max-width: 768px) {
    padding: 15px 0;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  
  img {
    max-height: 40px;
    width: auto;
    display: block;
  }
`;



const NavLinks = styled.div`
  display: flex;
  gap: 50px;
  margin: 0;
  flex: 1;
  justify-content: center;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background-color: white;
    flex-direction: column;
    padding: 20px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
    transform: translateY(-150%);
    transition: transform 0.3s ease;
    z-index: 100;
    margin: 0;
    justify-content: flex-start;
    display: none;
    
    &.active {
      transform: translateY(0);
      display: flex;
    }
  }
`;

const NavLink = styled.a`
  color: #222;
  text-decoration: none;
  font-weight: 300;
  font-size: 14px;
  transition: color 0.3s ease;
  padding: 5px 0;
  position: relative;
  
  &.active {
    color: #00Fa9a;
    
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #00Fa9a;
    }
  }
  
  &:hover {
    color: #00Fa9a;
  }
  
  @media (max-width: 768px) {
    padding: 10px 0;
  }
`;

const NavButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  justify-content: flex-end;
  
  // @media (max-width: 768px) {
  //   display: none;
  // }
`;

const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #222;
  margin-right: 10px;
  
  span {
    cursor: pointer;
    
    &:first-child {
      font-weight: 600;
    }
  }
`;

const LoginButton = styled.button`
  background-color: #00Fa9a;
  color: #222;
  border: none;
  border-radius: 30px;
  padding: 8px 24px;
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #00d68f;
  }
`;



const MenuToggle = styled.div`
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  
  span {
    display: block;
    width: 25px;
    height: 2px;
    background-color: #333;
    transition: all 0.3s ease;
  }
  
  @media (max-width: 768px) {
    display: flex;
  }
  
  &.active span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
    width: 35px;
  }
  
  &.active span:nth-child(2) {
    opacity: 0;
  }
  
  &.active span:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
    width: 35px;
  }
`;

export default Navbar;
